let items = 0;

// Helper function to create product list item
function createProductItem(dataId, dataImg, colId, pname) {
    return `
        <li class="active" id="${dataId}">
            <img src="${dataImg}">
            <h2 class="col-title">${colId}</h2>
            <h4 class="product-name">${pname}</h4>
            <button name="add" class="btn btn--full btn--transparent swatch__collection__content__button">
                <div class="swatch__collection__content__button__text remove__text">
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                        <path d="M7.125 0.875L0.875 7.125L7.125 0.875ZM0.875 0.875L7.125 7.125L0.875 0.875Z" fill="#D4DEDB"/>
                        <path d="M7.125 0.875L0.875 7.125M0.875 0.875L7.125 7.125" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                </div>
            </button>
        </li>
    `;
}

// Helper function to create hidden input
function createHiddenInput(dataId, pname, numberIndex) {
    return `<input type="hidden" data-id="${dataId}" value="Variant ID: ${dataId} / Variant Name: ${pname}" name="contact[Selected swatches${numberIndex}]" class="cdk_swatches_value">`;
}

// Update cart count
function updateCartCount(count) {
    document.querySelector(".mini-cart_count").innerText = count;
}

// Function to remove product from DOM
function removeProduct(dataId) {
    document.querySelectorAll(`#list-item li, #swatches-item li`).forEach(item => {
        if (item.id === dataId) {
            item.remove();
        }
    });
    document.querySelectorAll(`#data_value_hidden input`).forEach(input => {
        if (input.getAttribute('data-id') === dataId) {
            input.remove();
        }
    });
}
// Event listener for all swatch buttons
document.querySelectorAll(".swatch__collection__content__button").forEach(button => {
    button.addEventListener("click", function (e) {
        e.preventDefault();
        const parentProduct = this.closest(".materialproduct");
        const colId = parentProduct.getAttribute("col-id");
        const pname = parentProduct.getAttribute("data-title");
        const dataId = parentProduct.getAttribute("data-id");
        const dataImg = parentProduct.getAttribute("data-img");

        if (items < 5 || parentProduct.classList.contains("active")) {
            if (parentProduct.classList.contains("active")) {
                items--;
                updateCartCount(items);
                parentProduct.classList.remove("active");
                removeProduct(dataId);
            } else {
                items++;
                updateCartCount(items);
                parentProduct.classList.add("active");
                const productItem = createProductItem(dataId, dataImg, colId, pname);
                document.getElementById("list-item").insertAdjacentHTML("afterbegin", productItem);
                document.getElementById("swatches-item").insertAdjacentHTML("afterbegin", productItem);
                const hiddenInput = createHiddenInput(dataId, pname, items);
                document.getElementById("data_value_hidden").insertAdjacentHTML("beforeend", hiddenInput);
                document.querySelector(".material-cart").classList.add("show");
            }
            const cartButton = document.querySelector(".swatch__cart__button");
            if (items > 0) {
                cartButton.classList.remove("disable");
            } else {
                cartButton.classList.add("disable");
            }
        } else {
            // Show dialog if more than 5 items
            document.getElementById("dialog").style.display = "block";
        }
    });
});
// Function to handle the click event
function handleClose() {
  document.getElementById('material').style.display = 'none';
  document.querySelector('.popup-overlay').style.display = 'none';
  document.body.classList.remove('overflow-hidden');
}
window.addEventListener('scroll', function() {
  if (window.scrollY >= 400) {
    document.querySelector('.material-cart').classList.add('show');
  } else {
    document.querySelector('.material-cart').classList.remove('show');
  }
});

// document.addEventListener("click", function(event) {
//   if (event.target.matches(".mini-cart_items li button")) {
//     var compareId = event.target.closest('.mini-cart_items li').getAttribute('id');
//     console.log('compareId::' + compareId);

//     document.querySelectorAll('.materialproduct').forEach(function(element) {
//       var materalId = element.getAttribute('data-id');
//       console.log('materalId::' + materalId);

//       if (materalId == compareId) {
//         element.querySelector('.swatch__collection__content__button').click();
//       }
//     });
//   }
// });

document.addEventListener("click", function(event) {
    // Check if the clicked element is a button inside a .mini-cart_items li
    if (event.target.matches('.mini-cart_items li button')) {
        var compareId = event.target.parentElement.id; 
        console.log('compareId::' + compareId);

        // Get all elements with the class .materialproduct
        var materials = document.querySelectorAll('.materialproduct');
        materials.forEach(function(material) {
            var materialId = material.getAttribute('data-id'); 
            console.log('materialId::' + materialId);

            if (materialId === compareId) {
                // Trigger a click on the child button
                var button = material.querySelector('.swatch__collection__content__button');
                if (button) {
                    button.click();
                }
            }
        });
    }
});



document.addEventListener('click', function (event) {
  // Check if the clicked element is .mini-cart_items_Show-hide
  if (event.target.matches('.mini-cart_items_Show-hide')) {
    event.target.classList.toggle('active');
    var nextElement = event.target.nextElementSibling;
    if (nextElement && nextElement.matches('.mini-cart_content-wrapper')) {
      nextElement.classList.toggle('show');
    }
  }
});


// Attach the click event listener to elements
document.querySelectorAll('.material-form-close, .popup-overlay').forEach(function(element) {
  element.addEventListener('click', handleClose);
});
document.querySelectorAll('.closePop').forEach(function(element) {
  element.addEventListener('click', function() {
    document.getElementById('dialog').style.display = 'none';
  });
});
document.querySelectorAll('.cartform.swatch__cart__button').forEach(function(element) {
  element.addEventListener('click', function() {
    document.getElementById('material').style.display = 'block';
    document.querySelector('.popup-overlay').style.display = 'block';
    document.body.classList.add('overflow-hidden');
  });
});
// Handle click on .image-zoom-wrapper
document.addEventListener('click', function(e) {
  if (e.target.closest('.image-zoom-wrapper')) {
    e.preventDefault();
    e.stopPropagation();

    var mainImageElement = e.target.closest('.swatch__imag');
    if (mainImageElement) {
      var mainImage = mainImageElement.getAttribute('data_image');
      document.querySelector('.zoomed_image').setAttribute('src', mainImage);
      document.querySelector('.image_zoom_wrapper').style.display = 'block';
    }
  }
});

// Handle click on .close_zoom_wrapper
document.addEventListener('click', function(e) {
  if (e.target.closest('.close_zoom_wrapper')) {
    document.querySelector('.zoomed_image').setAttribute('src', '');
    document.querySelector('.image_zoom_wrapper').style.display = 'none';
  }
});

// Handle click outside of .zoom_wrapper to close it
document.addEventListener('mouseup', function(e) {
  var zoomWrapper = document.querySelector('.zoom_wrapper');
  if (zoomWrapper && !zoomWrapper.contains(e.target)) {
    document.querySelector('.zoomed_image').setAttribute('src', '');
    document.querySelector('.image_zoom_wrapper').style.display = 'none';
  }
});

// Handle click outside of #dialog to close it
document.addEventListener('mouseup', function(e) {
  var dialogWrapper = document.querySelector('.dialog-wrapper');
  if (dialogWrapper && !dialogWrapper.contains(e.target)) {
    document.getElementById('dialog').style.display = 'none';
  }
});
